import { queryOptions } from '@tanstack/react-query';

import { myApprovalsApi, type MyApprovalEntry } from '@/shared/api/approvals';

/**
 * The portal's approvals (`AM-238`, consequence): the approver of the customer's side holds
 * `approvals.act` and decides in the portal. Under `['portal']`, so a decision refreshes them the
 * same way an answer to a ticket refreshes the rest of the portal.
 */
export function pendingApprovalsQueryOptions() {
  return queryOptions({
    queryKey: ['portal', 'approvals', 'pending'] as const,
    queryFn: ({ signal }) => myApprovalsApi.list(signal),
  });
}

export function decidedApprovalsQueryOptions() {
  return queryOptions({
    queryKey: ['portal', 'approvals', 'decided'] as const,
    queryFn: ({ signal }) => myApprovalsApi.decided(signal),
  });
}

export function approvalQueryOptions(approvalId: string) {
  return queryOptions({
    queryKey: ['portal', 'approvals', 'detail', approvalId] as const,
    queryFn: ({ signal }) => myApprovalsApi.get(approvalId, signal),
  });
}

/** The number a person quotes the request or the ticket by; the approval's own reference when there is no subject. */
export function subjectNumberOf(entry: MyApprovalEntry): string | null {
  return entry.subject?.number ?? entry.request.entityReference ?? null;
}
